import React from 'react';
import { blockStyle, labelStyle, inputStyle, styles } from './trainAgentStyles';

export function TrainAgentConstraintsBlock({ vm }) {
  const {
    constraintsList,
    setConstraint,
    moveConstraint,
    removeConstraint,
    addConstraint
  } = vm;

  return (
    <div style={blockStyle}>
      <label style={labelStyle}>2. Restrições (constraints)</label>
      <p style={{ color: '#B0BEC5', fontSize: '13px', marginBottom: '12px' }}>
        Adicione uma restrição por vez. Marque &quot;Regra crítica&quot; para as que o bot nunca pode quebrar. Arraste com
        ↑/↓ para definir a prioridade (a primeira é a mais importante).
      </p>
      {constraintsList.map((c, i) => (
        <div key={i} style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'flex-start' }}>
          <input
            value={c.text}
            onChange={(e) => setConstraint(i, 'text', e.target.value)}
            placeholder="Ex.: Nunca faça mais de uma pergunta na mesma mensagem."
            style={{ ...inputStyle, flex: 1 }}
          />
          <label
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              color: '#B0BEC5',
              fontSize: '12px',
              whiteSpace: 'nowrap',
              marginTop: '12px'
            }}
          >
            <input
              type="checkbox"
              checked={c.critical}
              onChange={(e) => setConstraint(i, 'critical', e.target.checked)}
              style={{ cursor: 'pointer' }}
            />
            Regra crítica
          </label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '8px' }}>
            <button
              type="button"
              onClick={() => moveConstraint(i, 'up')}
              disabled={i === 0}
              style={{ ...styles.moveBtn, opacity: i === 0 ? 0.4 : 1 }}
              title="Subir (aumentar prioridade)"
            >
              ↑
            </button>
            <button
              type="button"
              onClick={() => moveConstraint(i, 'down')}
              disabled={i === constraintsList.length - 1}
              style={{
                ...styles.moveBtn,
                opacity: i === constraintsList.length - 1 ? 0.4 : 1
              }}
              title="Descer (diminuir prioridade)"
            >
              ↓
            </button>
          </div>
          <button type="button" onClick={() => removeConstraint(i)} style={styles.removeBtn} title="Remover restrição">
            −
          </button>
        </div>
      ))}
      <button type="button" onClick={addConstraint} style={styles.smallButton}>
        + Adicionar restrição
      </button>
    </div>
  );
}
